import $ from 'jquery';

export default class StaticGiftCard {
  constructor() {
    this.addQrCode();
  }

  addQrCode() {
    const qrWrapper = $('[data-qr-code]');
    new QRCode(qrWrapper[0], {
      text: qrWrapper.data('qr-code'),
      width: 120,
      height: 120,
    });
  }
}
